module.exports = __webpack_public_path__ + "img/12-fav.ecb519d8.svg";